import { getValueFromToken } from './getValueFromToken';

export const hideBookAccess = () => {
  return getValueFromToken('hideBooks');
};
